import onelps from '../../api';

export const loginStatus = async function(dispatchFn) {
	try {
		const result = await onelps.actions.loginStatus();

		return result;
	}
	catch(e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
};